import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { startViewerSession, viewerRouteInfo } from '../utils/viewerUsage';

// One usage report session per viewer page visit (utils/viewerUsage.ts):
// opening another viewer, or leaving the viewers, ends it.
export function useViewerUsage(): void {
  const { pathname } = useLocation();
  const route = viewerRouteInfo(pathname);
  const key = route ? [route.kind, route.projectId, route.shareToken, route.fileId].join('|') : '';
  useEffect(() => {
    if (!route) return undefined;
    return startViewerSession(route);
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
}
